// ANCARTA TECHNOLOGIES - Website Data (Light Theme)

export const companyInfo = {
  name: "ANCARTA",
  fullName: "ANCARTA TECHNOLOGIES PRIVATE LIMITED",
  tagline: "Digital Excellence",
  heroTitle: "Building Tomorrow's",
  heroHighlight: "Digital Infrastructure",
  heroDescription: "We deliver secure, scalable, and future-ready solutions for governments, enterprises, and global organizations with 20+ years of proven expertise.",
  yearsExperience: "20+",
  projectsDelivered: "50+",
  countriesServed: "15+",
  email: "info@ancarta.co.in",
  phone: "+91 8755910457",
  address: "Lucknow, Uttar Pradesh, India"
};

export const services = [
  {
    id: 1,
    title: "Digital Government",
    subtitle: "e-Governance Solutions",
    description: "National Identity & Permit Management, Immigration Platforms, Citizen Portals, Paperless Approval Systems, and Secure Data Exchange.",
    icon: "Landmark",
    color: "from-blue-500 to-cyan-500"
  },
  {
    id: 2,
    title: "Software Development",
    subtitle: "Custom Enterprise Solutions",
    description: "Enterprise Web & Mobile Apps, .NET Core / Microservices, API-First Platforms, and Legacy System Modernization.",
    icon: "Code",
    color: "from-cyan-500 to-teal-500"
  },
  {
    id: 3,
    title: "Cloud & DevOps",
    subtitle: "Infrastructure Excellence",
    description: "AWS, Azure, GCP Architecture, CI/CD Automation, Docker & Kubernetes, Infrastructure as Code with Terraform.",
    icon: "Cloud",
    color: "from-blue-600 to-indigo-600"
  },
  {
    id: 4,
    title: "Cybersecurity",
    subtitle: "Compliance & Protection",
    description: "Secure-by-Design Architecture, Identity & Access Management, Audit Readiness, and Data Protection Governance.",
    icon: "ShieldCheck",
    color: "from-slate-700 to-slate-900"
  },
  {
    id: 5,
    title: "ERP Systems",
    subtitle: "Enterprise Resource Planning",
    description: "ERP Design & Implementation, SAP & Microsoft Dynamics NAV, Process Automation, and MIS Reporting.",
    icon: "Database",
    color: "from-cyan-600 to-blue-600"
  },
  {
    id: 6,
    title: "AI & Analytics",
    subtitle: "Smart Platforms",
    description: "Workflow Intelligence, Predictive Analytics, Operational Optimization, and AI-Powered Automation.",
    icon: "Sparkles",
    color: "from-indigo-500 to-blue-500"
  }
];

export const strengths = [
  { id: 1, value: "20+", label: "Years Experience", icon: "Trophy" },
  { id: 2, value: "50+", label: "Projects Delivered", icon: "Rocket" },
  { id: 3, value: "15+", label: "Countries Served", icon: "Globe" },
  { id: 4, value: "100%", label: "Client Satisfaction", icon: "Heart" }
];

export const industries = [
  { id: 1, name: "Government & Public Sector", icon: "Building2" },
  { id: 2, name: "Immigration & Border Control", icon: "Plane" },
  { id: 3, name: "Smart Cities", icon: "Building" },
  { id: 4, name: "Manufacturing & ERP", icon: "Factory" },
  { id: 5, name: "Healthcare", icon: "HeartPulse" },
  { id: 6, name: "Financial Services", icon: "Wallet" }
];

export const expertise = [
  "Digital Government & e-Governance Programs",
  "Cloud & DevOps Transformation (AWS, Azure, GCP)",
  "Enterprise .NET & API-First Architecture",
  "Secure National-Scale Platforms",
  "Program Management with Government Authorities"
];

export const vision = "To become a trusted global technology partner for governments and enterprises by delivering secure, intelligent, and scalable digital platforms that drive transparency, efficiency, and long-term value.";

export const mission = "To transform complex processes into simple, digital, and resilient systems using modern technology, strong governance, and engineering excellence.";

export const images = {
  // Software Consulting - Professional developer at work
  hero: "https://images.unsplash.com/photo-1580894894513-541e068a3e2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzY5MTkwODExfDA&ixlib=rb-4.1.0&q=85",
  // Dual monitor coding setup
  coding: "https://images.unsplash.com/photo-1656680632373-e2aec264296b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzY5MTkwODExfDA&ixlib=rb-4.1.0&q=85",
  // Professional consultant with laptop
  consultant: "https://images.unsplash.com/photo-1657727534685-36b09f84e193?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGNvbnN1bHRpbmd8ZW58MHx8fHwxNzY5MTkwODExfDA&ixlib=rb-4.1.0&q=85",
  // Team meeting collaboration
  team: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxhbmFseXRpY3MlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzY5MTMwMTg1fDA&ixlib=rb-4.1.0&q=85",
  // Business data analysis graphs
  dataAnalysis: "https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxhbmFseXRpY3MlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzY5MTMwMTg1fDA&ixlib=rb-4.1.0&q=85",
  // Professional developers working
  developers: "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg",
  // Mobile app development
  mobileApp: "https://images.unsplash.com/photo-1633250391894-397930e3f5f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2JpbGUlMjBhcHAlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjkxNzYwMDZ8MA&ixlib=rb-4.1.0&q=85",
  // Developer with mobile app
  mobileApp2: "https://images.unsplash.com/photo-1595675024853-0f3ec9098ac7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtb2JpbGUlMjBhcHAlMjBkZXZlbG9wbWVudHxlbnwwfHx8fDE3NjkxNzYwMDZ8MA&ixlib=rb-4.1.0&q=85",
  // Code on screen - technical expertise
  code: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg",
  // Admin dashboard placeholder
  adminDashboard: "https://images.pexels.com/photos/577210/pexels-photo-577210.jpeg"
};
